<template>
  <div>
    <section class="section is-title-bar">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <p class="title is-5">EDit CCTV Declaration form upload</p>
          </div>
        </div>
      </div>
    </section>
    <form @submit.prevent="onSubmit" enctype="multipart/form-data" name="SaveWowKitMapping">
      <card-component>
        <template>
          <div class="columns is-mobile">
              <div class="column ">
                <div class="content">
                  <b> Validation points:<br /></b>
                  <ul>
                    <li>File size: Maximum 10MB</li>
                  </ul>
                </div>
              </div>
              <div class="column ">
                <section class="text-is-centered">
                  <b-field>
                    <b-upload v-model="dropFiles" @input="handleFileUpload" single drag-drop title="Please do upload .pdf,.png and jpeg file only">
                      <section class="section">
                        <div class="content has-text-centered">
                          <p>
                            <b-icon icon="upload" size="is-large"> </b-icon>
                          </p>
                          <p>Drop your files here or click to upload</p>
                        </div>
                      </section>
                    </b-upload>
                  </b-field>
                  <div v-if="dropFiles.name" class="tags">
                    <span class="tag is-primary">
                      {{ dropFiles.name }}
                      <button class="delete is-small" type="button" @click="deleteDropFile()"></button>
                    </span>
                  </div>
                </section>
              </div>
              <div class="column has-text-centered">
              </div>
            </div>
            <footer class="column has-text-centered">
              <button class="button is-success" type="submit">Save</button>
            </footer>
        </template>
      </card-component>
    </form>
    <loading-icon :value="isLoading" />
  </div>
</template>
<script>
import CardComponent from '@/components/template/CardComponent'
import constants from '@/utils/constants'

export default {
  name: 'cctvDocUpload',
  components: {
    CardComponent
  },
  props: ['cctvDocId'],

  data () {
    return {
      dropFiles: [],
      allowedFormats: ['image/png', 'application/pdf', 'image/jpeg'],
      userObj: {
        cctvDocUpload: null
      },
      // loadingComponent: null
      isLoading: false,
      cctvData: []
    }
  },

  created: function () {
  },
  methods: {
    handleFileUpload (files) {
      this.dropFiles = files
    },
    async onSubmit (event) {
      let that = this
      this.isLoading = true

      try {
        if (!that.dropFiles) {
          return this.errMsg('Please select a document to upload.')
        }
        if (that.dropFiles && that.dropFiles.name) {
          const fileType = that.dropFiles.type
          const maxFileSize = 10 * 1024 * 1024 // 10 MB
          const file = that.dropFiles
          const fileSize = file.size

          if (!this.allowedFormats.includes(fileType)) {
            this.errMsg('Invalid file format. Please upload a JPG or PDF file.')
            return
          }

          if (fileSize > maxFileSize) {
            this.errMsg('File size too large. Please upload a file under 10MB.')
          }
        }
        let formData = new FormData()
        formData.append('cctvDoc', that.dropFiles)
        if (this.cctvDocId) {
          await http.post(`${constants.API_URL}/api/audit/cctv-doc/update?id=${this.cctvDocId}`, formData)
          this.okMsg('CCTV Declaration Form has been successfully uploaded!')
          this.$router.push({ name: 'cctvDocUpload' })
        }
      } catch (e) {
        this.isLoading = false

        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error while uploading cctv document', errorMessage)

        return this.errMsg(errorMessage)
      }
    },
    deleteDropFile () {
      this.dropFiles = {}
    },
    okMsg (msg) {
      return this.$dialog.info({
        title: 'Success',
        text: msg
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }
  }
}
</script>
<style scoped>

</style>
